import {faCog} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FunctionComponent} from 'react';
import {Link} from 'react-router-dom';

import {mainState} from '../../AppMainState';
import {AppRoutes, createLogLink, logOverviewLink, projectDashboardLink, settingsLink} from '../../routing/AppRoutes';
import {Button} from '../../components/Button';
import {Card} from '../../components/Card';

export const ProjectsView: FunctionComponent<any> = observer(() => {
    return <section id="projects-list" className="h-full" data-tut="projects-list">
        <h1 className="font-bold font-roboto-bold mb-4 text-3xl">Projects list</h1>
        <Card>
            <Link className="btn btn-primary my-4 w-full" to={AppRoutes.CreateProject}>Add new project</Link>
            <ul id="projects">
                {mainState.projects && mainState.projects.map(p =>
                    <li className="mb-4" key={'sidebarproject' + p.projectId}>
                        <div className="flex items-center justify-between mb-3">
                            <h2><Link to={projectDashboardLink(p.projectId!)}>{p.name}</Link></h2>
                            {!mainState.isDemoUser && <Link to={settingsLink(p.projectId!)}><FontAwesomeIcon
                                className="fill-current text-m-gray-6" icon={faCog} /></Link>}
                        </div>
                        {p.logs?.length === 0 && <Button className="btn btn-primary w-full md:w-auto">
                            <Link to={createLogLink(p.projectId!)}>Add new log</Link>
                        </Button>}
                        {p.logs?.length !== 0 &&
                            <ul className="bg-m-gray-2 px-4 py-2 rounded-md" id="logs">
                                {p.logs!.map(l =>
                                    <li className="flex items-center" key={'logId' + l.logId}>
                                        <span className="list-item-bullet mr-4"></span>
                                        <Link className="inline-block w-full" to={logOverviewLink(l.logId!)}>{l.name}</Link>
                                    </li>)}
                            </ul>}
                    </li>
                )}
            </ul>
        </Card>
    </section>
        ;
});
